import { render } from "./Grading.vue?vue&type=template&id=05229c99"
import script from "./Grading.vue?vue&type=script&lang=js"
export * from "./Grading.vue?vue&type=script&lang=js"

import "./Grading.vue?vue&type=style&index=0&id=05229c99&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__